export const getFlightsJourney = (flights) => {
  const { origin } = flights[0];
  const { destination } = flights[flights.length - 1];

  return {
    origin,
    destination,
  };
};

const formatFlightsJourney = (flights, codeOnly) => {
  const { origin, destination } = getFlightsJourney(flights);

  const key = codeOnly ? 'code' : 'name';

  return `${origin[key]} to ${destination[key]}`;
};

export default formatFlightsJourney;
